// react
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// core components
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

// material-ui icons
import Check from "@material-ui/icons/Check";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/headerProcessoFinal.js";

const useStyles = makeStyles(styles);

export default function HeaderProcessoFinal({etapa}) { 
    const { t } = useTranslation();
    const classes = useStyles();

    useEffect(() => {  
        if(etapa === undefined)
            etapa = 0;
    }, [etapa]);

return (
    <div className="no-print">    
        <Card>
        <CardBody className={classes.cardHeaderProcessoVenda}>                  
        <GridContainer >   
        <GridItem xs={3} sm={3} md={3} className={classes.gridHeader} > 

            <div className={classes.boxProcess}>
                <div className={classes.boxItem}>
                    <div className={classes.iconItem  +" "+  classes.iconCheck}>
                        <Check className={classes.icoSize} />
                    </div>
                    {t('sale.my_cart')}
                </div>
                <div className={etapa === 0 ? classes.lineProcessRight +" "+ classes.lineLight : classes.lineProcessRight +" "+ classes.lineDark}></div>
            </div>

        </GridItem>          
        <GridItem xs={3} sm={3} md={3} className={classes.gridHeader} > 

            <div className={classes.boxProcess}>
                <div className={classes.boxItem}>
                    <div className={etapa < 1 ?classes.iconItem +" "+ classes.iconUnCheck: classes.iconItem +" "+ classes.iconCheck }>
                        <Check className={etapa < 1 ? classes.noneCheck :  classes.icoSize } />
                    </div>
                    {t('sale.customer_data')}                    
                </div>                 
                <div  className={etapa < 1 ? classes.lineProcessLeft +" "+classes.lineLight: classes.lineProcessLeft +" "+classes.lineDark } ></div> 
                <div  className={etapa > 1 ? classes.lineProcessRight +" "+classes.lineDark: classes.lineProcessRight +" "+classes.lineLight } ></div>                  
            </div>


        </GridItem>        
        <GridItem xs={3} sm={3} md={3} className={classes.gridHeader} >            
            
            <div className={classes.boxProcess}>
                <div className={classes.boxItem}>
                    <div className={etapa < 2 ?classes.iconItem +" "+ classes.iconUnCheck: classes.iconItem +" "+ classes.iconCheck }>
                        <Check className={etapa < 2 ? classes.noneCheck :  classes.icoSize } />
                    </div>
                    {t('label.payment')}                    
                </div>                 
                <div  className={etapa < 2 ? classes.lineProcessLeft +" "+classes.lineLight: classes.lineProcessLeft +" "+classes.lineDark } ></div> 
                <div  className={etapa > 2 ? classes.lineProcessRight +" "+classes.lineDark: classes.lineProcessRight +" "+classes.lineLight } ></div>                  
            </div>

        </GridItem>        
        <GridItem xs={3} sm={3} md={3} className={classes.gridHeader} >            
            
            <div className={classes.boxProcess}>
                <div className={classes.boxItem}>
                    <div className={etapa < 3 ?classes.iconItem +" "+ classes.iconUnCheck: classes.iconItem +" "+ classes.iconCheck }>
                        <Check className={etapa < 3 ? classes.noneCheck :  classes.icoSize } />
                    </div>
                    {t('label.thank_you')}                    
                </div>                 
                <div  className={etapa < 3 ? classes.lineProcessLeft +" "+classes.lineLight: classes.lineProcessLeft +" "+classes.lineDark } ></div> 
            </div>

        </GridItem>
        </GridContainer> 
        </CardBody>  
        </Card>

    </div>
);
}